<template>
  <div :class="classnames">
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'modal-content'

  export default {
    name: 'ModalContent',
    mixins: [ bem ],
    props: {
      isOpen: Boolean,
      viewName: [ Object, String ]
    },
    data: function () {
      return {}
    },
    created: function () {
      this.setNamespace(namespace)
    },
    methods: {
      classnameModifiers: function () {
        const viewName = this.viewName

        return [
          viewName
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Modal/ModalContent.vue